import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON,
  SystemCodeToJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface UserMemo {
  id: number
  date: string
  place: SystemCode
  memo: string
  displayStartDate: { input: string; errorMessage: string }
  displayEndDate: { input: string; errorMessage: string }
  opacDisplay: boolean
  userCheckedTime: string
  _userCheckedTimeDeleteFlag: boolean
  revision: number
  _delete: boolean
}

export function UserMemoFromJSON(json: any): UserMemo {
  return {
    id: json.id,
    date: exists(json, 'date') ? dateToPlainFormat(json.date) : '',
    place: exists(json, 'place')
      ? SystemCodeFromJSON(json.place)
      : defaultSystemCode(),
    memo: exists(json, 'memo') ? json.memo : '',
    displayStartDate: {
      input: exists(json, 'display_start_date')
        ? dateToPlainFormat(json.display_start_date)
        : '',
      errorMessage: ''
    },
    displayEndDate: {
      input: exists(json, 'display_end_date')
        ? dateToPlainFormat(json.display_end_date)
        : '',
      errorMessage: ''
    },
    opacDisplay: json.opac_display,
    userCheckedTime: exists(json, 'user_checked_time')
      ? dateToPlainFormat(json.user_checked_time)
      : '',
    _userCheckedTimeDeleteFlag: false,
    revision: json.revision,
    _delete: false
  }
}

export function UserMemoToJSON(value: UserMemo): any {
  return {
    id: value.id,
    date: value.date,
    place: SystemCodeToJSON(value.place),
    memo: value.memo,
    display_start_date: value.displayStartDate.input,
    display_end_date: value.displayEndDate.input,
    opac_display: value.opacDisplay,
    _user_checked_time_delete_flag: value._userCheckedTimeDeleteFlag,
    revision: value.revision,
    _delete: value._delete
  }
}

export const defaultUserMemo = (): UserMemo => ({
  id: 0,
  date: '',
  place: defaultSystemCode(),
  memo: '',
  displayStartDate: { input: '', errorMessage: '' },
  displayEndDate: { input: '', errorMessage: '' },
  opacDisplay: false,
  userCheckedTime: '',
  _userCheckedTimeDeleteFlag: false,
  revision: 1,
  _delete: false
})
